import { render, staticRenderFns } from "./SaleLevelUp.vue?vue&type=template&id=5d54fb60"
import script from "./SaleLevelUp.vue?vue&type=script&lang=js"
export * from "./SaleLevelUp.vue?vue&type=script&lang=js"
import style0 from "./SaleLevelUp.vue?vue&type=style&index=0&id=5d54fb60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports